// Layout Types
import { DefaultLayout } from "../layouts";

// Route Views
import NotFound from '../components/common/NotFound';

const NotFoundRoute = [
  {
    layout: DefaultLayout,
    component: NotFound
  },
];
export default NotFoundRoute;
